export const ORDER_STATUS_TIMELINE_GHOST = 100;
export const ORDER_DETAILS_IMAGES_GHOST = 150;
export const ORDER_DETAILS_CARD_GHOST = 400;
export const ORDER_DETAILS_SUMMARY_GHOST = 400;
export const ORDER_DETAILS_PRODUCT_DETAILS_GHOST = 400;
export const ORDER_DETAILS_NOTES_GHOST = 150;
export const ORDER_DETAILS_HEADER_GHOST = 50;